var module = angular.module('octopusApp.projects');

module.directive('actionSummary', function($templateCache, $compile, $injector, octopusLog, pluginRegistry, octopusClient) {
  return {
    restrict: 'E',
    replace: true,
    transclude: false,
    scope: {
      action: '=',
      step: '=',
      number: '=',
      editLink: '='
    },
    templateUrl: 'areas/projects/views/action_summary.html',
    link: function(scope, element) {
      var action = scope.action;
      var step = scope.step;
      if (!action || !step) {
        return;
      }

      scope.isSingleStep = step.Actions.length === 1;
      scope.properties = $.extend({}, action.Properties, step.Properties);

      octopusLog.info("Finding registered deployment action for action type: " + action.ActionType);

      var plugin = pluginRegistry.getDeploymentAction(action.ActionType);
      if (!plugin) {
        octopusLog.error("Unknown action type: ", action.ActionType);
        return;
      }

      var actionId = action.Properties['Octopus.Action.Template.Id'];
      var typeOrId =  actionId ? actionId : action.ActionType;
      scope.logoUrl = octopusClient.resolveLinkTemplate("ActionTemplateLogo", {typeOrId : typeOrId});
      var viewTemplateUrl = plugin.summaryTemplateUrl;
      octopusLog.info("Resolving view template: ", viewTemplateUrl);

      var template = $templateCache.get(viewTemplateUrl);
      if (!template) {
        octopusLog.info("Could not find view template in the template cache: ", viewTemplateUrl);
        return;
      }

      var child = $compile(template)(scope);
      if (plugin.summaryLink) {
        plugin.summaryLink(scope, child);
      }

      var actionBody = $('.action-details', element);
      actionBody.html('');
      actionBody.html(child);
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/directives/action_summary.js
// module id = 534
// module chunks = 1